<template>
    <k-panel class="border">
        <k-panel-row v-if="trancheType == 'LENDING'">
            <div slot="left">
                <img src="/img/icon/done_all.svg" class="inline-block mr-2 icon">
                Kilde rating
            </div>
            <div slot="right">{{ borrower.creditRating }}</div>
        </k-panel-row>
        <k-panel-row>
            <div slot="left">
                <img src="/img/icon/map.svg" class="inline-block mr-2 icon">
                {{ $t("countries") }}
            </div>
            <k-country-flags slot="right" :countries="borrower.countries"></k-country-flags>
        </k-panel-row>
        <k-panel-row>
            <div slot="left">
                <img src="/img/icon/list_ul.svg" class="inline-block mr-2 icon">
                Product types
            </div>
            <div slot="right">
                <div v-for="product in borrower.productTypes" class="text-right">
                    {{ product }}&nbsp;
                </div>
            </div>
        </k-panel-row>
        <div v-if="trancheType == 'REAL_ESTATE'">
            <k-panel-row>
                <div slot="left">
                    <img src="/img/icon/building.svg" class="inline-block mr-2 icon">
                    Number of projects
                </div>
                <div slot="right">{{ borrower.numberOfProjects }}</div>
            </k-panel-row>
            <k-panel-row>
                <div slot="left">
                    <img src="/img/icon/home_check.svg" class="inline-block mr-2 icon">
                    Current projects
                </div>
                <div slot="right">{{ borrower.currentProjects }}</div>
            </k-panel-row>
            <k-panel-row>
                <div slot="left">
                    <img src="/img/icon/clock.svg" class="inline-block mr-2 icon">
                    Experience
                </div>
                <div slot="right">{{ borrower.yearsOfExperience }} years</div>
            </k-panel-row>
        </div>
        <div v-if="trancheType == 'LENDING'">
            <k-panel-row>
                <div slot="left">
                    <img src="/img/icon/bar_chart_alt.svg" class="inline-block mr-2 icon">
                    {{ $t("loansOriginated") }}
                </div>
                <div slot="right">{{ borrower.loansOriginated | currencyFormat(borrower.currencySymbol) }}</div>
            </k-panel-row>
            <k-panel-row>
                <div slot="left">
                    <img src="/img/icon/file_blank_outline.svg" class="inline-block mr-2 icon">
                    {{ $t("loanPortfolio") }}
                </div>
                <div slot="right">{{ borrower.loansPortfolio | currencyFormat(borrower.currencySymbol) }}</div>
            </k-panel-row>
            <k-panel-row>
                <div slot="left">
                    <img src="/img/icon/data.svg" class="inline-block mr-2 icon">
                    {{ $t("borrowingOnKilde") }}
                </div>
            </k-panel-row>
            <k-panel-row v-for="item in borrower.borrowingsOnPlatform" v-bind:key="item.currencyCode">
                <div slot="left">
                    <div class="left-indentation">Bond in {{ item.currencyCode }}</div>
                </div>
                <div slot="right">{{ item.borrowingOnPlatform | currencyFormat(item.currencySymbol) }}</div>
            </k-panel-row>
            <k-panel-row>
                <div slot="left">
                    <img src="/img/icon/calendar_calendar.svg" class="inline-block mr-2 icon">
                    {{ $t("foundedYear") }}
                </div>
                <div slot="right">{{ borrower.foundedYear }}</div>
            </k-panel-row>
        </div>
        <k-panel-row>
            <div slot="left">
                <img src="/img/icon/id_card.svg" class="inline-block mr-2 icon">
                {{ $t("numberOfEmployees") }}
            </div>
            <div slot="right">{{ borrower.numberOfEmployees }}</div>
        </k-panel-row>
        <k-panel-row>
            <div slot="left">
                <img src="/img/icon/window.svg" class="inline-block mr-2 icon">
                Site
            </div>
            <div slot="right"><a :href="borrower.companyWebsite">{{ borrower.companyWebsite }}</a></div>
        </k-panel-row>
    </k-panel>
</template>

<script>
export default {
    props: {
        borrower: {
            type: Object,
            required: true
        },
        trancheType: {
            type: String,
            required: true
        }
    }
};
</script>

<style scoped>
.icon {
    max-height: 12px;
    max-width: 12px;
}
</style>

